import {SAVER_COMMITS,SAVER_DISPATCHS} from '@/store/contracts'
const state = {
    unsavedActions: {}
}
const getters ={
    isUnsaved(state){
        for (const _ in state.unsavedActions) {
            return true
        }
        return false
    }
}
const mutations = {
    [SAVER_COMMITS.REQUIRE_SAVE]: (state,{key, execute})=>{
        if(!state.unsavedActions[key]){
            state.unsavedActions[key] = {execute}
        }
    },
    [SAVER_COMMITS.CANCEL_SAVE]: (state,key)=>{
        if(state.unsavedActions[key]){
            delete state.unsavedActions[key]
        }
    }
}
const actions = {
    async [SAVER_DISPATCHS.SUBMIT]({ commit, state }) {
        const actions = Object.values(state.unsavedActions)
        if(actions && actions.length){
            const actionKeys = Object.keys(state.unsavedActions)
            const allPromises = actions.map(a=>a.execute().catch(e=>e))
            return Promise.all(allPromises).then((values)=>{
                //返回哪些成功，哪些失败
                const result = {successed:[], failed:[]}
                values.map((v,index)=>{
                    
                    const key = actionKeys[index]
                    if(v && v.error){
                        result.failed.push(key)
                    }else{
                        //commit(SAVER_COMMITS.CANCEL_SAVE, {key})
                        result.successed.push(key)
                    }
                })
                return result

            })
        }
        
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}